export function run(callback) {
  return callback();
}
